import React from 'react'
import '../App.css';

function Footer(){
    return(
        <div className='footer'>
             +91 9947144333
        </div>
    )

}
export default Footer;